import Radio from './radio';
import Group from './group';

Radio.Group = Group;

export default Radio;